import classNames from 'classnames';
import { ContentBlock, FlexContainer, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useTenancy } from 'state';
import { ViewPaymentsList } from '../../../../bricks';
import styles from './ViewPaymentsRentPayments.module.scss';

/**
 * ViewPaymentsRentPayments
 *
 * @return {JSX.Element}
 */
const ViewPaymentsRentPayments = ({ className }) => {
  const tenancyState = useTenancy();
  const {
    payments: {
      isInitialized,
      mapped: { rentData: payments },
    },
  } = tenancyState;

  return (
    <FlexContainer
      className={classNames(
        styles.ViewPaymentsRentPayments,
        className,
        ViewPaymentsRentPayments.displayName
      )}
      column
    >
      {isInitialized ? (
        payments.length ? (
          <ViewPaymentsList data={payments} />
        ) : (
          <ContentBlock column gapHalf>
            <Txt x>No Rent Payments</Txt>
            <Txt regular>
              A notification is sent on the rent due date, if the deposit isn't
              paid a notification will be sent to all parties.
            </Txt>
            <Txt regular>Propa will check again 24 hours later.</Txt>
          </ContentBlock>
        )
      ) : null}
    </FlexContainer>
  );
};

ViewPaymentsRentPayments.displayName = 'ViewPaymentsRentPayments';

export default observer(ViewPaymentsRentPayments);
